module.exports = __webpack_public_path__ + "media/pling.568c4522.mp3";